import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AnnualRenewalModule } from './products/annual-renewal/annual-renewal.module';
import { AnnualRenewalPayNowModule } from './products/annual-renewal-paynow/annual-renewal-paynow.module'
//import { ProductListComponent } from './checkout/shared/product-list/product-list.component';

import { CheckoutModule } from './checkout/checkout.module';
import { CredentialVerificationModule } from './products/credential-verification/credential-verification.module';

import { OtherProductComponent } from './products/other-product/other-product.component';
import { PurchaseComponent } from './purchase.component';
import { SharedModule } from './../shared/modules/shared.module'
import { PurchaseService } from './shared/services/purchase.service';
//import { PurchaseStateService } from './shared/services/purchase-state.service';

import { DecimalPipe } from '@angular/common';
import { NgxMaskModule } from 'ngx-mask';

@NgModule({
  imports: [
    AnnualRenewalModule,
    AnnualRenewalPayNowModule,
    CheckoutModule,
    CredentialVerificationModule,    
    RouterModule,
    SharedModule,
    NgxMaskModule.forChild()
  ],
  declarations: [    
    OtherProductComponent,
    PurchaseComponent,
    //ProductListComponent
  ],
  providers: [
    DecimalPipe,
    PurchaseService
  //  PurchaseStateService
  ]
})
export class PurchaseModule { }
